import React from "react";

const SomeWrongHappened = () => {

    return (
        <div className="purchase-order-block">
            Something went wrong, Please try again!!!
        </div>
    )
}

export default SomeWrongHappened;